import React from 'react'
import { getNextUuid, useSlsStateContext } from '@fs/zion-sls'
import { trackEvent } from '@fs/zion-analytics'
import { useTranslation } from 'react-i18next'
import { useOverlayContext } from '../../../../../../shared/providers/overlayContextProvider/OverlayContext'
import { useR2DispatchContext } from '../../../../../providers/r2Provider/R2Context'
import InfoSectionHeader from './InfoSectionHeader'
import IndexInfoSection from './IndexInfoSection'

const NamesSection = ({ nameElements, isRestrictedEssentialInfo, disableEdit, selectedPerson }) => {
  const { openOverlay, infoSheetOverlay } = useOverlayContext()
  const dispatch = useR2DispatchContext()
  const zionSlsState = useSlsStateContext()
  const { t } = useTranslation()

  return (
    <>
      {nameElements && (
        <>
          {nameElements.map((ne, i) => {
            return (
              <IndexInfoSection
                element={ne}
                key={ne.id}
                onEditClick={() => {
                  openOverlay('editEssentialInfo')
                  trackEvent({
                    event_name: 'click_action',
                    link_name: `Edit: Essential Info: Open`,
                  })
                  const addedSexId = getNextUuid()
                  dispatch({ type: 'SET_STATE', value: { addedSexId } })
                }}
                disableEditButton={isRestrictedEssentialInfo || disableEdit}
                slsTypes={zionSlsState.types}
                isBottomSheet={infoSheetOverlay?.isBottomSheet}
                showPrincipalName={i === 0 && selectedPerson.primary}
                hideHeader={i !== 0}
                growX
              />
            )
          })}
        </>
      )}
      {(!nameElements || nameElements.length === 0) && (
        <InfoSectionHeader
          element={{
            label: t('view-index.essential.title', 'Essential Information'),
            elementType: 'NAME',
          }}
          disabled={isRestrictedEssentialInfo || disableEdit}
          onEditClick={() => {
            openOverlay('editEssentialInfo')
            trackEvent({
              event_name: 'click_action',
              link_name: `Edit: Essential Info: Open`,
            })
          }}
          isBottomSheet={infoSheetOverlay?.isBottomSheet}
        />
      )}
    </>
  )
}

export default NamesSection
